/**
 * Shared Cognito configuration for AWS Amplify
 *
 * This configuration is used by both:
 * - Client-side Amplify setup (components/Cognito/index.tsx)
 * - Server-side Amplify setup (lib/auth/amplify-server-util.tsx)
 *
 * Environment Variables:
 * NEXT_PUBLIC_AWS_USER_POOL_CLIENT_ID: The app client ID from Cognito
 * NEXT_PUBLIC_AWS_USER_POOL_ID: The user pool ID from Cognito
 *
 * Note: Using NEXT_PUBLIC_ prefix because this config is needed in the browser.
 * In a client-server hybrid setup, these values must be accessible in both contexts.
 */

export const cognitoConfig = {
	Auth: {
		Cognito: {
			userPoolClientId: process.env
				.NEXT_PUBLIC_AWS_USER_POOL_CLIENT_ID as string,
			userPoolId: process.env.NEXT_PUBLIC_AWS_USER_POOL_ID as string,
		},
	},
};

export default cognitoConfig;
